import { createTranslations } from '@npco/common-utils-translations'

export const velocityWindowSummaryTranslations = createTranslations({
  summary: 'Resets at {endOfWindow} · Limit {limit}',
  endOfWindow: '{remainingTimeText} · {window}',
})
